// extracted by mini-css-extract-plugin
module.exports = {"toggle":"BigToggleButton_toggle__2r0uw","toggleButton":"BigToggleButton_toggleButton__1Ahtj","toggleHighlight":"BigToggleButton_toggleHighlight__3khnv"};